// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { addCourse, assignUsers, assignUsersToChecklist, browseStructure, cloneAsSystemPlan, clonePlan, createAnswer, createPlan, createQuiz, deleteCategoryByCountryCodeAndId, deleteCourse, deleteDocument, deleteQuiz, diff, generateCourseReport, getActivePlanAssignments, getAllCourses, getAuth, getCategoriesByCountryCode, getCategory, getCategoryIcons, getCategoryV2, getComplianceCourses, getConfiguration, getCourseById, getDocument, getExperimentsConfig, getManagedPlans, getOperatorCourseSettings, getOperators, getPlanAndAssignments, getPlanReport, getPlansSummary, getProcedureIcons, getQuizDetails, getQuizzes, getResource, getSmartSearchLocations, getSqssl, getSystemPlans, getTranslations, getUserPlanAssignmentSummaries, getUserPreferences, getUsers, getUsersForLocations, getUsersSummaryReport, getUserSummaryReport, hardDeleteQuiz, heartbeat, heartbeatTrainTogether, learnUponWebhook, listEnrollmentsByCourse, markPlanAsComplete, type Options, patchAutoAssign, patchPlanName, patchPlanStatus, patchQuizName, resetPlanSteps, rewritePlanReferences, runDatasetExperiment, saveCategories, saveCategory, saveDocuments, saveUserPreferences, search, searchClickFeedback, setAuthCookie, setOperatorCourseSetting, swap, synchronizeUser, trainTogetherMarkPlanAsComplete, trainTogetherUpdateStepStatus, unassignUsers, updateCourse, updateDueDate, updatePlan, updateQuiz, updateSmartSearchOptIn, updateStepStatus, updateUserComplianceCourseDuration, upsertReadonlySubscription, upsertSmartSearchFeedback, webhookQuiz } from '../sdk.gen';
import type { AddCourseData, AddCourseError, AddCourseResponse, AssignUsersData, AssignUsersError, AssignUsersToChecklistData, AssignUsersToChecklistError, BrowseStructureData, BrowseStructureError, BrowseStructureResponse, CloneAsSystemPlanData, CloneAsSystemPlanError, CloneAsSystemPlanResponse, ClonePlanData, ClonePlanError, ClonePlanResponse, CreateAnswerData, CreateAnswerError, CreateAnswerResponse, CreatePlanData, CreatePlanError, CreatePlanResponse, CreateQuizData, CreateQuizError, CreateQuizResponse, DeleteCategoryByCountryCodeAndIdData, DeleteCategoryByCountryCodeAndIdError, DeleteCategoryByCountryCodeAndIdResponse, DeleteCourseData, DeleteCourseError, DeleteDocumentData, DeleteDocumentError, DeleteDocumentResponse, DeleteQuizData, DeleteQuizError, DiffData, DiffError, DiffResponse, GenerateCourseReportData, GenerateCourseReportError, GenerateCourseReportResponse, GetActivePlanAssignmentsData, GetActivePlanAssignmentsError, GetActivePlanAssignmentsResponse, GetAllCoursesData, GetAllCoursesError, GetAllCoursesResponse, GetAuthData, GetAuthError, GetAuthResponse, GetCategoriesByCountryCodeData, GetCategoriesByCountryCodeError, GetCategoriesByCountryCodeResponse, GetCategoryData, GetCategoryError, GetCategoryIconsData, GetCategoryIconsError, GetCategoryIconsResponse, GetCategoryV2Data, GetCategoryV2Error, GetCategoryV2Response, GetComplianceCoursesData, GetComplianceCoursesError, GetComplianceCoursesResponse, GetConfigurationData, GetConfigurationError, GetConfigurationResponse, GetCourseByIdData, GetCourseByIdError, GetCourseByIdResponse, GetDocumentData, GetDocumentError, GetDocumentResponse, GetExperimentsConfigData, GetExperimentsConfigError, GetExperimentsConfigResponse, GetManagedPlansData, GetManagedPlansError, GetManagedPlansResponse, GetOperatorCourseSettingsData, GetOperatorCourseSettingsError, GetOperatorCourseSettingsResponse, GetOperatorsData, GetOperatorsError, GetOperatorsResponse, GetPlanAndAssignmentsData, GetPlanAndAssignmentsError, GetPlanAndAssignmentsResponse, GetPlanReportData, GetPlanReportError, GetPlanReportResponse, GetPlansSummaryData, GetPlansSummaryError, GetPlansSummaryResponse, GetProcedureIconsData, GetProcedureIconsError, GetProcedureIconsResponse, GetQuizDetailsData, GetQuizDetailsError, GetQuizDetailsResponse, GetQuizzesData, GetQuizzesError, GetQuizzesResponse, GetResourceData, GetResourceError, GetResourceResponse, GetSmartSearchLocationsData, GetSmartSearchLocationsError, GetSmartSearchLocationsResponse, GetSqsslData, GetSqsslError, GetSqsslResponse, GetSystemPlansData, GetSystemPlansError, GetSystemPlansResponse, GetTranslationsData, GetTranslationsError, GetTranslationsResponse, GetUserPlanAssignmentSummariesData, GetUserPlanAssignmentSummariesError, GetUserPlanAssignmentSummariesResponse, GetUserPreferencesData, GetUserPreferencesError, GetUserPreferencesResponse, GetUsersData, GetUsersError, GetUsersForLocationsData, GetUsersForLocationsError, GetUsersForLocationsResponse, GetUsersResponse, GetUsersSummaryReportData, GetUsersSummaryReportError, GetUsersSummaryReportResponse, GetUserSummaryReportData, GetUserSummaryReportError, GetUserSummaryReportResponse, HardDeleteQuizData, HardDeleteQuizError, HeartbeatData, HeartbeatError, HeartbeatResponse, HeartbeatTrainTogetherData, HeartbeatTrainTogetherError, HeartbeatTrainTogetherResponse, LearnUponWebhookData, LearnUponWebhookError, LearnUponWebhookResponse, ListEnrollmentsByCourseData, ListEnrollmentsByCourseError, ListEnrollmentsByCourseResponse, MarkPlanAsCompleteData, MarkPlanAsCompleteError, MarkPlanAsCompleteResponse, PatchAutoAssignData, PatchAutoAssignError, PatchAutoAssignResponse, PatchPlanNameData, PatchPlanNameError, PatchPlanNameResponse, PatchPlanStatusData, PatchPlanStatusError, PatchPlanStatusResponse, PatchQuizNameData, PatchQuizNameError, PatchQuizNameResponse, ResetPlanStepsData, ResetPlanStepsError, ResetPlanStepsResponse, RewritePlanReferencesData, RewritePlanReferencesError, RewritePlanReferencesResponse, RunDatasetExperimentData, RunDatasetExperimentError, RunDatasetExperimentResponse, SaveCategoriesData, SaveCategoriesError, SaveCategoriesResponse, SaveCategoryData, SaveCategoryError, SaveCategoryResponse, SaveDocumentsData, SaveDocumentsError, SaveUserPreferencesData, SaveUserPreferencesError, SaveUserPreferencesResponse, SearchClickFeedbackData, SearchClickFeedbackError, SearchData, SearchError, SearchResponse2, SetAuthCookieData, SetAuthCookieError, SetOperatorCourseSettingData, SetOperatorCourseSettingError, SwapData, SwapError, SwapResponse, SynchronizeUserData, SynchronizeUserError, TrainTogetherMarkPlanAsCompleteData, TrainTogetherMarkPlanAsCompleteError, TrainTogetherMarkPlanAsCompleteResponse, TrainTogetherUpdateStepStatusData, TrainTogetherUpdateStepStatusError, TrainTogetherUpdateStepStatusResponse, UnassignUsersData, UnassignUsersError, UnassignUsersResponse, UpdateCourseData, UpdateCourseError, UpdateCourseResponse, UpdateDueDateData, UpdateDueDateError, UpdateDueDateResponse, UpdatePlanData, UpdatePlanError, UpdatePlanResponse, UpdateQuizData, UpdateQuizError, UpdateQuizResponse, UpdateSmartSearchOptInData, UpdateSmartSearchOptInError, UpdateSmartSearchOptInResponse, UpdateStepStatusData, UpdateStepStatusError, UpdateStepStatusResponse, UpdateUserComplianceCourseDurationData, UpdateUserComplianceCourseDurationError, UpsertReadonlySubscriptionData, UpsertReadonlySubscriptionError, UpsertReadonlySubscriptionResponse, UpsertSmartSearchFeedbackData, UpsertSmartSearchFeedbackError, UpsertSmartSearchFeedbackResponse, WebhookQuizData, WebhookQuizError } from '../types.gen';

/**
 * Generate a grounded AI answer for a natural-language query
 *
 * Server-to-server endpoint for answering questions based on CFA procedures
 */
export const createAnswerMutation = (options?: Partial<Options<CreateAnswerData>>): UseMutationOptions<CreateAnswerResponse, CreateAnswerError, Options<CreateAnswerData>> => {
    const mutationOptions: UseMutationOptions<CreateAnswerResponse, CreateAnswerError, Options<CreateAnswerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAnswer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Run a dataset experiment
 *
 * Triggers an asynchronous experiment that runs each dataset item through the answers pipeline and reports results back to Langfuse as dataset run items.
 */
export const runDatasetExperimentMutation = (options?: Partial<Options<RunDatasetExperimentData>>): UseMutationOptions<RunDatasetExperimentResponse, RunDatasetExperimentError, Options<RunDatasetExperimentData>> => {
    const mutationOptions: UseMutationOptions<RunDatasetExperimentResponse, RunDatasetExperimentError, Options<RunDatasetExperimentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runDatasetExperiment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getExperimentsConfigQueryKey = (options?: Options<GetExperimentsConfigData>) => createQueryKey('getExperimentsConfig', options);

/**
 * Retrieve Langfuse configuration for dataset experiments
 *
 * Returns Langfuse configuration from the Pathway project needed to set up dataset experiments.
 */
export const getExperimentsConfigOptions = (options?: Options<GetExperimentsConfigData>) => queryOptions<GetExperimentsConfigResponse, GetExperimentsConfigError, GetExperimentsConfigResponse, ReturnType<typeof getExperimentsConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExperimentsConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExperimentsConfigQueryKey(options)
});

export const getAuthQueryKey = (options?: Options<GetAuthData>) => createQueryKey('getAuth', options);

/**
 * Sets the authorization cookies and returns the users profile / feature set
 */
export const getAuthOptions = (options?: Options<GetAuthData>) => queryOptions<GetAuthResponse, GetAuthError, GetAuthResponse, ReturnType<typeof getAuthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthQueryKey(options)
});

export const browseStructureQueryKey = (options?: Options<BrowseStructureData>) => createQueryKey('browseStructure', options);

/**
 * Get Browse structure
 *
 * Returns complete browse structure by Country and Language
 */
export const browseStructureOptions = (options?: Options<BrowseStructureData>) => queryOptions<BrowseStructureResponse, BrowseStructureError, BrowseStructureResponse, ReturnType<typeof browseStructureQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await browseStructure({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: browseStructureQueryKey(options)
});

export const getCategoriesByCountryCodeQueryKey = (options?: Options<GetCategoriesByCountryCodeData>) => createQueryKey('getCategoriesByCountryCode', options);

/**
 * Get Categories by Country Code
 */
export const getCategoriesByCountryCodeOptions = (options?: Options<GetCategoriesByCountryCodeData>) => queryOptions<GetCategoriesByCountryCodeResponse, GetCategoriesByCountryCodeError, GetCategoriesByCountryCodeResponse, ReturnType<typeof getCategoriesByCountryCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoriesByCountryCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoriesByCountryCodeQueryKey(options)
});

/**
 * Add or update Categories List
 */
export const saveCategoriesMutation = (options?: Partial<Options<SaveCategoriesData>>): UseMutationOptions<SaveCategoriesResponse, SaveCategoriesError, Options<SaveCategoriesData>> => {
    const mutationOptions: UseMutationOptions<SaveCategoriesResponse, SaveCategoriesError, Options<SaveCategoriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveCategories({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add or update single category
 */
export const saveCategoryMutation = (options?: Partial<Options<SaveCategoryData>>): UseMutationOptions<SaveCategoryResponse, SaveCategoryError, Options<SaveCategoryData>> => {
    const mutationOptions: UseMutationOptions<SaveCategoryResponse, SaveCategoryError, Options<SaveCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCategoryV2QueryKey = (options: Options<GetCategoryV2Data>) => createQueryKey('getCategoryV2', options);

/**
 * Get Category (v2)
 */
export const getCategoryV2Options = (options: Options<GetCategoryV2Data>) => queryOptions<GetCategoryV2Response, GetCategoryV2Error, GetCategoryV2Response, ReturnType<typeof getCategoryV2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoryV2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryV2QueryKey(options)
});

/**
 * Delete category by Country and ID
 */
export const deleteCategoryByCountryCodeAndIdMutation = (options?: Partial<Options<DeleteCategoryByCountryCodeAndIdData>>): UseMutationOptions<DeleteCategoryByCountryCodeAndIdResponse, DeleteCategoryByCountryCodeAndIdError, Options<DeleteCategoryByCountryCodeAndIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteCategoryByCountryCodeAndIdResponse, DeleteCategoryByCountryCodeAndIdError, Options<DeleteCategoryByCountryCodeAndIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCategoryByCountryCodeAndId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCategoryQueryKey = (options: Options<GetCategoryData>) => createQueryKey('getCategory', options);

/**
 * Get Category
 */
export const getCategoryOptions = (options: Options<GetCategoryData>) => queryOptions<unknown, GetCategoryError, unknown, ReturnType<typeof getCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryQueryKey(options)
});

export const getConfigurationQueryKey = (options?: Options<GetConfigurationData>) => createQueryKey('getConfiguration', options);

/**
 * Returns the list of configured versions.
 *
 * Returns the list of configured versions.
 */
export const getConfigurationOptions = (options?: Options<GetConfigurationData>) => queryOptions<GetConfigurationResponse, GetConfigurationError, GetConfigurationResponse, ReturnType<typeof getConfigurationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConfiguration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConfigurationQueryKey(options)
});

export const getAllCoursesQueryKey = (options?: Options<GetAllCoursesData>) => createQueryKey('getAllCourses', options);

/**
 * List All Courses
 *
 * List All Courses
 *
 * @deprecated
 */
export const getAllCoursesOptions = (options?: Options<GetAllCoursesData>) => queryOptions<GetAllCoursesResponse, GetAllCoursesError, GetAllCoursesResponse, ReturnType<typeof getAllCoursesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllCourses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllCoursesQueryKey(options)
});

/**
 * Add a Course
 *
 * @deprecated
 */
export const addCourseMutation = (options?: Partial<Options<AddCourseData>>): UseMutationOptions<AddCourseResponse, AddCourseError, Options<AddCourseData>> => {
    const mutationOptions: UseMutationOptions<AddCourseResponse, AddCourseError, Options<AddCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign one or more Team members to a Checklist
 *
 * @deprecated
 */
export const assignUsersToChecklistMutation = (options?: Partial<Options<AssignUsersToChecklistData>>): UseMutationOptions<unknown, AssignUsersToChecklistError, Options<AssignUsersToChecklistData>> => {
    const mutationOptions: UseMutationOptions<unknown, AssignUsersToChecklistError, Options<AssignUsersToChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignUsersToChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEnrollmentsByCourseQueryKey = (options: Options<ListEnrollmentsByCourseData>) => createQueryKey('listEnrollmentsByCourse', options);

/**
 * Status of all current enrollments to this course by optional location
 *
 * @deprecated
 */
export const listEnrollmentsByCourseOptions = (options: Options<ListEnrollmentsByCourseData>) => queryOptions<ListEnrollmentsByCourseResponse, ListEnrollmentsByCourseError, ListEnrollmentsByCourseResponse, ReturnType<typeof listEnrollmentsByCourseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEnrollmentsByCourse({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEnrollmentsByCourseQueryKey(options)
});

export const getComplianceCoursesQueryKey = (options?: Options<GetComplianceCoursesData>) => createQueryKey('getComplianceCourses', options);

/**
 * Gets compliance courses based on country selected in user's profile
 *
 * @deprecated
 */
export const getComplianceCoursesOptions = (options?: Options<GetComplianceCoursesData>) => queryOptions<GetComplianceCoursesResponse, GetComplianceCoursesError, GetComplianceCoursesResponse, ReturnType<typeof getComplianceCoursesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getComplianceCourses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getComplianceCoursesQueryKey(options)
});

export const generateCourseReportQueryKey = (options: Options<GenerateCourseReportData>) => createQueryKey('generateCourseReport', options);

/**
 * Sensitive data report on course by location
 *
 * @deprecated
 */
export const generateCourseReportOptions = (options: Options<GenerateCourseReportData>) => queryOptions<GenerateCourseReportResponse, GenerateCourseReportError, GenerateCourseReportResponse, ReturnType<typeof generateCourseReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generateCourseReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generateCourseReportQueryKey(options)
});

export const getOperatorCourseSettingsQueryKey = (options: Options<GetOperatorCourseSettingsData>) => createQueryKey('getOperatorCourseSettings', options);

/**
 * Returns course settings for an operator
 *
 * @deprecated
 */
export const getOperatorCourseSettingsOptions = (options: Options<GetOperatorCourseSettingsData>) => queryOptions<GetOperatorCourseSettingsResponse, GetOperatorCourseSettingsError, GetOperatorCourseSettingsResponse, ReturnType<typeof getOperatorCourseSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOperatorCourseSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOperatorCourseSettingsQueryKey(options)
});

/**
 * Enables or Disables a course for an operator
 *
 * @deprecated
 */
export const setOperatorCourseSettingMutation = (options?: Partial<Options<SetOperatorCourseSettingData>>): UseMutationOptions<unknown, SetOperatorCourseSettingError, Options<SetOperatorCourseSettingData>> => {
    const mutationOptions: UseMutationOptions<unknown, SetOperatorCourseSettingError, Options<SetOperatorCourseSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOperatorCourseSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSqsslQueryKey = (options: Options<GetSqsslData>) => createQueryKey('getSqssl', options);

/**
 * Get SQSSO
 *
 * @deprecated
 */
export const getSqsslOptions = (options: Options<GetSqsslData>) => queryOptions<GetSqsslResponse, GetSqsslError, GetSqsslResponse, ReturnType<typeof getSqsslQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSqssl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSqsslQueryKey(options)
});

/**
 * Synchronize User with LearnUpon
 *
 * @deprecated
 */
export const synchronizeUserMutation = (options?: Partial<Options<SynchronizeUserData>>): UseMutationOptions<unknown, SynchronizeUserError, Options<SynchronizeUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, SynchronizeUserError, Options<SynchronizeUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await synchronizeUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle LearnUpon webhook event
 *
 * @deprecated
 */
export const learnUponWebhookMutation = (options?: Partial<Options<LearnUponWebhookData>>): UseMutationOptions<LearnUponWebhookResponse, LearnUponWebhookError, Options<LearnUponWebhookData>> => {
    const mutationOptions: UseMutationOptions<LearnUponWebhookResponse, LearnUponWebhookError, Options<LearnUponWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await learnUponWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Course by ID
 *
 * @deprecated
 */
export const deleteCourseMutation = (options?: Partial<Options<DeleteCourseData>>): UseMutationOptions<unknown, DeleteCourseError, Options<DeleteCourseData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteCourseError, Options<DeleteCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a course
 *
 * @deprecated
 */
export const updateCourseMutation = (options?: Partial<Options<UpdateCourseData>>): UseMutationOptions<UpdateCourseResponse, UpdateCourseError, Options<UpdateCourseData>> => {
    const mutationOptions: UseMutationOptions<UpdateCourseResponse, UpdateCourseError, Options<UpdateCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCourseByIdQueryKey = (options: Options<GetCourseByIdData>) => createQueryKey('getCourseById', options);

/**
 * Get Course by ID
 *
 * @deprecated
 */
export const getCourseByIdOptions = (options: Options<GetCourseByIdData>) => queryOptions<GetCourseByIdResponse, GetCourseByIdError, GetCourseByIdResponse, ReturnType<typeof getCourseByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCourseById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCourseByIdQueryKey(options)
});

/**
 * Set course status by ID
 *
 * @deprecated
 */
export const updateUserComplianceCourseDurationMutation = (options?: Partial<Options<UpdateUserComplianceCourseDurationData>>): UseMutationOptions<unknown, UpdateUserComplianceCourseDurationError, Options<UpdateUserComplianceCourseDurationData>> => {
    const mutationOptions: UseMutationOptions<unknown, UpdateUserComplianceCourseDurationError, Options<UpdateUserComplianceCourseDurationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserComplianceCourseDuration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add or update documents
 */
export const saveDocumentsMutation = (options?: Partial<Options<SaveDocumentsData>>): UseMutationOptions<unknown, SaveDocumentsError, Options<SaveDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, SaveDocumentsError, Options<SaveDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setAuthCookieQueryKey = (options?: Options<SetAuthCookieData>) => createQueryKey('setAuthCookie', options);

/**
 * Sets auth cookie in response header
 */
export const setAuthCookieOptions = (options?: Options<SetAuthCookieData>) => queryOptions<unknown, SetAuthCookieError, unknown, ReturnType<typeof setAuthCookieQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await setAuthCookie({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: setAuthCookieQueryKey(options)
});

/**
 * Delete document by ID
 */
export const deleteDocumentMutation = (options?: Partial<Options<DeleteDocumentData>>): UseMutationOptions<DeleteDocumentResponse, DeleteDocumentError, Options<DeleteDocumentData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentResponse, DeleteDocumentError, Options<DeleteDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentQueryKey = (options: Options<GetDocumentData>) => createQueryKey('getDocument', options);

/**
 * Get document by ID
 */
export const getDocumentOptions = (options: Options<GetDocumentData>) => queryOptions<GetDocumentResponse, GetDocumentError, GetDocumentResponse, ReturnType<typeof getDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentQueryKey(options)
});

export const getCategoryIconsQueryKey = (options?: Options<GetCategoryIconsData>) => createQueryKey('getCategoryIcons', options);

/**
 * Get a list of all category icons
 */
export const getCategoryIconsOptions = (options?: Options<GetCategoryIconsData>) => queryOptions<GetCategoryIconsResponse, GetCategoryIconsError, GetCategoryIconsResponse, ReturnType<typeof getCategoryIconsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoryIcons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryIconsQueryKey(options)
});

export const getProcedureIconsQueryKey = (options?: Options<GetProcedureIconsData>) => createQueryKey('getProcedureIcons', options);

/**
 * Get a list of all procedure icons
 */
export const getProcedureIconsOptions = (options?: Options<GetProcedureIconsData>) => queryOptions<GetProcedureIconsResponse, GetProcedureIconsError, GetProcedureIconsResponse, ReturnType<typeof getProcedureIconsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProcedureIcons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProcedureIconsQueryKey(options)
});

export const getPlansSummaryQueryKey = (options?: Options<GetPlansSummaryData>) => createQueryKey('getPlansSummary', options);

/**
 * Get a report on all plans a user has build access to
 *
 * Get a report on all plans a user has build access to, status default is ACTIVE
 */
export const getPlansSummaryOptions = (options?: Options<GetPlansSummaryData>) => queryOptions<GetPlansSummaryResponse, GetPlansSummaryError, GetPlansSummaryResponse, ReturnType<typeof getPlansSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlansSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlansSummaryQueryKey(options)
});

export const getPlanReportQueryKey = (options: Options<GetPlanReportData>) => createQueryKey('getPlanReport', options);

/**
 * Get a report for all users on a specific plan
 *
 * Get a report for all users on a specific plan
 */
export const getPlanReportOptions = (options: Options<GetPlanReportData>) => queryOptions<GetPlanReportResponse, GetPlanReportError, GetPlanReportResponse, ReturnType<typeof getPlanReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanReportQueryKey(options)
});

export const getUsersSummaryReportQueryKey = (options: Options<GetUsersSummaryReportData>) => createQueryKey('getUsersSummaryReport', options);

/**
 * Get a report on all users plan progress for the passed in location numbers.
 *
 * Returns summary of user's overall plan progress on all active plans at the passed in location numbers.
 */
export const getUsersSummaryReportOptions = (options: Options<GetUsersSummaryReportData>) => queryOptions<GetUsersSummaryReportResponse, GetUsersSummaryReportError, GetUsersSummaryReportResponse, ReturnType<typeof getUsersSummaryReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsersSummaryReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersSummaryReportQueryKey(options)
});

export const getUserSummaryReportQueryKey = (options: Options<GetUserSummaryReportData>) => createQueryKey('getUserSummaryReport', options);

/**
 * Get a detailed plan summary report for a specific user
 *
 * Get a detailed plan summary report for a specific user
 */
export const getUserSummaryReportOptions = (options: Options<GetUserSummaryReportData>) => queryOptions<GetUserSummaryReportResponse, GetUserSummaryReportError, GetUserSummaryReportResponse, ReturnType<typeof getUserSummaryReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserSummaryReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserSummaryReportQueryKey(options)
});

export const getManagedPlansQueryKey = (options?: Options<GetManagedPlansData>) => createQueryKey('getManagedPlans', options);

/**
 * Get manage plans for user's owner ids
 *
 * Get manage plans for logged in user's owner ids
 */
export const getManagedPlansOptions = (options?: Options<GetManagedPlansData>) => queryOptions<GetManagedPlansResponse, GetManagedPlansError, GetManagedPlansResponse, ReturnType<typeof getManagedPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getManagedPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getManagedPlansQueryKey(options)
});

/**
 * Create a new plan.
 */
export const createPlanMutation = (options?: Partial<Options<CreatePlanData>>): UseMutationOptions<CreatePlanResponse, CreatePlanError, Options<CreatePlanData>> => {
    const mutationOptions: UseMutationOptions<CreatePlanResponse, CreatePlanError, Options<CreatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActivePlanAssignmentsQueryKey = (options?: Options<GetActivePlanAssignmentsData>) => createQueryKey('getActivePlanAssignments', options);

/**
 * Get active assigned plans for user
 *
 * Get active assigned plans for logged in user
 */
export const getActivePlanAssignmentsOptions = (options?: Options<GetActivePlanAssignmentsData>) => queryOptions<GetActivePlanAssignmentsResponse, GetActivePlanAssignmentsError, GetActivePlanAssignmentsResponse, ReturnType<typeof getActivePlanAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActivePlanAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActivePlanAssignmentsQueryKey(options)
});

export const getSystemPlansQueryKey = (options?: Options<GetSystemPlansData>) => createQueryKey('getSystemPlans', options);

/**
 * Get all active system plans for user's business models
 *
 * Get active system plans for logged in user's business models
 */
export const getSystemPlansOptions = (options?: Options<GetSystemPlansData>) => queryOptions<GetSystemPlansResponse, GetSystemPlansError, GetSystemPlansResponse, ReturnType<typeof getSystemPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemPlansQueryKey(options)
});

export const getPlanAndAssignmentsQueryKey = (options: Options<GetPlanAndAssignmentsData>) => createQueryKey('getPlanAndAssignments', options);

/**
 * Get plan by id along with all of its active assignments
 *
 * Get plan by id along with all of its active assignments
 */
export const getPlanAndAssignmentsOptions = (options: Options<GetPlanAndAssignmentsData>) => queryOptions<GetPlanAndAssignmentsResponse, GetPlanAndAssignmentsError, GetPlanAndAssignmentsResponse, ReturnType<typeof getPlanAndAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanAndAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanAndAssignmentsQueryKey(options)
});

/**
 * Update a plan.
 */
export const updatePlanMutation = (options?: Partial<Options<UpdatePlanData>>): UseMutationOptions<UpdatePlanResponse, UpdatePlanError, Options<UpdatePlanData>> => {
    const mutationOptions: UseMutationOptions<UpdatePlanResponse, UpdatePlanError, Options<UpdatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign users from plan.
 */
export const unassignUsersMutation = (options?: Partial<Options<UnassignUsersData>>): UseMutationOptions<UnassignUsersResponse, UnassignUsersError, Options<UnassignUsersData>> => {
    const mutationOptions: UseMutationOptions<UnassignUsersResponse, UnassignUsersError, Options<UnassignUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unassignUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign plan to users.
 */
export const assignUsersMutation = (options?: Partial<Options<AssignUsersData>>): UseMutationOptions<unknown, AssignUsersError, Options<AssignUsersData>> => {
    const mutationOptions: UseMutationOptions<unknown, AssignUsersError, Options<AssignUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark a plan as auto assignable.
 *
 * Allows a user to mark a plan as auto assignable.
 */
export const patchAutoAssignMutation = (options?: Partial<Options<PatchAutoAssignData>>): UseMutationOptions<PatchAutoAssignResponse, PatchAutoAssignError, Options<PatchAutoAssignData>> => {
    const mutationOptions: UseMutationOptions<PatchAutoAssignResponse, PatchAutoAssignError, Options<PatchAutoAssignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAutoAssign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clone a plan.
 */
export const clonePlanMutation = (options?: Partial<Options<ClonePlanData>>): UseMutationOptions<ClonePlanResponse, ClonePlanError, Options<ClonePlanData>> => {
    const mutationOptions: UseMutationOptions<ClonePlanResponse, ClonePlanError, Options<ClonePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clonePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clone a plan as a system plan.
 */
export const cloneAsSystemPlanMutation = (options?: Partial<Options<CloneAsSystemPlanData>>): UseMutationOptions<CloneAsSystemPlanResponse, CloneAsSystemPlanError, Options<CloneAsSystemPlanData>> => {
    const mutationOptions: UseMutationOptions<CloneAsSystemPlanResponse, CloneAsSystemPlanError, Options<CloneAsSystemPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cloneAsSystemPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a users plan due date.
 *
 * Changes when a user's plan is due by.
 */
export const updateDueDateMutation = (options?: Partial<Options<UpdateDueDateData>>): UseMutationOptions<UpdateDueDateResponse, UpdateDueDateError, Options<UpdateDueDateData>> => {
    const mutationOptions: UseMutationOptions<UpdateDueDateResponse, UpdateDueDateError, Options<UpdateDueDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDueDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark plan as complete when all steps are complete.
 *
 * Records when a user is complete with a plan.
 */
export const markPlanAsCompleteMutation = (options?: Partial<Options<MarkPlanAsCompleteData>>): UseMutationOptions<MarkPlanAsCompleteResponse, MarkPlanAsCompleteError, Options<MarkPlanAsCompleteData>> => {
    const mutationOptions: UseMutationOptions<MarkPlanAsCompleteResponse, MarkPlanAsCompleteError, Options<MarkPlanAsCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markPlanAsComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates the plan name.
 *
 * Updates the plan name. The name must be a localized `TranslatedField` with
 * at least one non-blank translation, and each translation must not exceed 200 characters.
 */
export const patchPlanNameMutation = (options?: Partial<Options<PatchPlanNameData>>): UseMutationOptions<PatchPlanNameResponse, PatchPlanNameError, Options<PatchPlanNameData>> => {
    const mutationOptions: UseMutationOptions<PatchPlanNameResponse, PatchPlanNameError, Options<PatchPlanNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchPlanName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Allow users to opt-in or out of readonly plans.
 *
 * Subscribes a location/operator to a readonly plan.
 */
export const upsertReadonlySubscriptionMutation = (options?: Partial<Options<UpsertReadonlySubscriptionData>>): UseMutationOptions<UpsertReadonlySubscriptionResponse, UpsertReadonlySubscriptionError, Options<UpsertReadonlySubscriptionData>> => {
    const mutationOptions: UseMutationOptions<UpsertReadonlySubscriptionResponse, UpsertReadonlySubscriptionError, Options<UpsertReadonlySubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertReadonlySubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a plan's status.
 *
 * Allows a user to archive and unarchive a plan.
 */
export const patchPlanStatusMutation = (options?: Partial<Options<PatchPlanStatusData>>): UseMutationOptions<PatchPlanStatusResponse, PatchPlanStatusError, Options<PatchPlanStatusData>> => {
    const mutationOptions: UseMutationOptions<PatchPlanStatusResponse, PatchPlanStatusError, Options<PatchPlanStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchPlanStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resets all the steps in a plan.
 *
 * Resets all the steps in a plan to incomplete.
 */
export const resetPlanStepsMutation = (options?: Partial<Options<ResetPlanStepsData>>): UseMutationOptions<ResetPlanStepsResponse, ResetPlanStepsError, Options<ResetPlanStepsData>> => {
    const mutationOptions: UseMutationOptions<ResetPlanStepsResponse, ResetPlanStepsError, Options<ResetPlanStepsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetPlanSteps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update duration for logged in user's plan and step.
 *
 * Records how long a user takes on a given plan and step.
 */
export const heartbeatMutation = (options?: Partial<Options<HeartbeatData>>): UseMutationOptions<HeartbeatResponse, HeartbeatError, Options<HeartbeatData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatResponse, HeartbeatError, Options<HeartbeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates a step status to complete.
 *
 * Updates a single step status to complete.
 */
export const updateStepStatusMutation = (options?: Partial<Options<UpdateStepStatusData>>): UseMutationOptions<UpdateStepStatusResponse, UpdateStepStatusError, Options<UpdateStepStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateStepStatusResponse, UpdateStepStatusError, Options<UpdateStepStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStepStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update duration for passed in user's plan and step in train together.
 *
 * Records how long the passed in users take on the given plan and step in train together.
 */
export const heartbeatTrainTogetherMutation = (options?: Partial<Options<HeartbeatTrainTogetherData>>): UseMutationOptions<HeartbeatTrainTogetherResponse, HeartbeatTrainTogetherError, Options<HeartbeatTrainTogetherData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatTrainTogetherResponse, HeartbeatTrainTogetherError, Options<HeartbeatTrainTogetherData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeatTrainTogether({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark the passed in plan's step status for the user ids in training mode.
 */
export const trainTogetherUpdateStepStatusMutation = (options?: Partial<Options<TrainTogetherUpdateStepStatusData>>): UseMutationOptions<TrainTogetherUpdateStepStatusResponse, TrainTogetherUpdateStepStatusError, Options<TrainTogetherUpdateStepStatusData>> => {
    const mutationOptions: UseMutationOptions<TrainTogetherUpdateStepStatusResponse, TrainTogetherUpdateStepStatusError, Options<TrainTogetherUpdateStepStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trainTogetherUpdateStepStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark plan as complete for the passed user ids in training together.
 *
 * Records when a user is complete with a plan in training together.
 */
export const trainTogetherMarkPlanAsCompleteMutation = (options?: Partial<Options<TrainTogetherMarkPlanAsCompleteData>>): UseMutationOptions<TrainTogetherMarkPlanAsCompleteResponse, TrainTogetherMarkPlanAsCompleteError, Options<TrainTogetherMarkPlanAsCompleteData>> => {
    const mutationOptions: UseMutationOptions<TrainTogetherMarkPlanAsCompleteResponse, TrainTogetherMarkPlanAsCompleteError, Options<TrainTogetherMarkPlanAsCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trainTogetherMarkPlanAsComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQuizzesQueryKey = (options?: Options<GetQuizzesData>) => createQueryKey('getQuizzes', options);

/**
 * Gets a list of quizzes
 *
 * Gets a list of owned Classic and Knowledge quizzes
 */
export const getQuizzesOptions = (options?: Options<GetQuizzesData>) => queryOptions<GetQuizzesResponse, GetQuizzesError, GetQuizzesResponse, ReturnType<typeof getQuizzesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getQuizzes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQuizzesQueryKey(options)
});

/**
 * Create a quiz
 */
export const createQuizMutation = (options?: Partial<Options<CreateQuizData>>): UseMutationOptions<CreateQuizResponse, CreateQuizError, Options<CreateQuizData>> => {
    const mutationOptions: UseMutationOptions<CreateQuizResponse, CreateQuizError, Options<CreateQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Hard-delete a quiz (maintenance)
 *
 * Lower-env maintenance cleanup. Removes pathway quiz metadata and Typeform form. Callers supply typeFormId. Forbidden in production.
 */
export const hardDeleteQuizMutation = (options?: Partial<Options<HardDeleteQuizData>>): UseMutationOptions<unknown, HardDeleteQuizError, Options<HardDeleteQuizData>> => {
    const mutationOptions: UseMutationOptions<unknown, HardDeleteQuizError, Options<HardDeleteQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hardDeleteQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a quiz
 */
export const deleteQuizMutation = (options?: Partial<Options<DeleteQuizData>>): UseMutationOptions<unknown, DeleteQuizError, Options<DeleteQuizData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteQuizError, Options<DeleteQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQuizDetailsQueryKey = (options: Options<GetQuizDetailsData>) => createQueryKey('getQuizDetails', options);

/**
 * Get quiz details
 */
export const getQuizDetailsOptions = (options: Options<GetQuizDetailsData>) => queryOptions<GetQuizDetailsResponse, GetQuizDetailsError, GetQuizDetailsResponse, ReturnType<typeof getQuizDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getQuizDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQuizDetailsQueryKey(options)
});

/**
 * Update a quiz
 */
export const updateQuizMutation = (options?: Partial<Options<UpdateQuizData>>): UseMutationOptions<UpdateQuizResponse, UpdateQuizError, Options<UpdateQuizData>> => {
    const mutationOptions: UseMutationOptions<UpdateQuizResponse, UpdateQuizError, Options<UpdateQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates the quiz name.
 *
 * Updates the quiz name. The name must be a localized `TranslatedField` with at least one
 * non-blank translation. The primary-language value is limited to 250 characters;
 * other translations may be up to 750 characters (knowledge based quizzes only).
 */
export const patchQuizNameMutation = (options?: Partial<Options<PatchQuizNameData>>): UseMutationOptions<PatchQuizNameResponse, PatchQuizNameError, Options<PatchQuizNameData>> => {
    const mutationOptions: UseMutationOptions<PatchQuizNameResponse, PatchQuizNameError, Options<PatchQuizNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchQuizName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const diffQueryKey = (options: Options<DiffData>) => createQueryKey('diff', options);

/**
 * Preview a resource swap.
 *
 * Compares persistent and temporary resources, returns an afterSwap projection when both exist, and enriches subtitle placements with browse category paths.
 */
export const diffOptions = (options: Options<DiffData>) => queryOptions<DiffResponse, DiffError, DiffResponse, ReturnType<typeof diffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diffQueryKey(options)
});

/**
 * Swap a temporary resource onto a persistent resource.
 *
 * Swaps resource content references and returns affected categories requiring review.
 */
export const swapMutation = (options?: Partial<Options<SwapData>>): UseMutationOptions<SwapResponse, SwapError, Options<SwapData>> => {
    const mutationOptions: UseMutationOptions<SwapResponse, SwapError, Options<SwapData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await swap({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rewrite plan step resource references.
 *
 * Proxies to plans-data-api to publish an asynchronous plan-job that rewrites matching plan step references from one resource to another. Usable as a standalone rewrite or after a resource swap. Returns 202 with the published job id.
 */
export const rewritePlanReferencesMutation = (options?: Partial<Options<RewritePlanReferencesData>>): UseMutationOptions<RewritePlanReferencesResponse, RewritePlanReferencesError, Options<RewritePlanReferencesData>> => {
    const mutationOptions: UseMutationOptions<RewritePlanReferencesResponse, RewritePlanReferencesError, Options<RewritePlanReferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rewritePlanReferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getResourceQueryKey = (options: Options<GetResourceData>) => createQueryKey('getResource', options);

/**
 * Get a resource
 *
 * Returns complete resource structure by id
 */
export const getResourceOptions = (options: Options<GetResourceData>) => queryOptions<GetResourceResponse, GetResourceError, GetResourceResponse, ReturnType<typeof getResourceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getResource({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getResourceQueryKey(options)
});

export const searchQueryKey = (options: Options<SearchData>) => createQueryKey('search', options);

/**
 * Search for results
 *
 * Searches for resources by query, country and language. Returns document results along with optional GenAI smart answers. Smart answers include source attribution with document titles, URLs, text excerpts, and confidence scores.
 */
export const searchOptions = (options: Options<SearchData>) => queryOptions<SearchResponse2, SearchError, SearchResponse2, ReturnType<typeof searchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchQueryKey(options)
});

/**
 * Submit click feedback for a result
 *
 * Improves search results by submitting click feedback for a specific result and query.
 */
export const searchClickFeedbackMutation = (options?: Partial<Options<SearchClickFeedbackData>>): UseMutationOptions<unknown, SearchClickFeedbackError, Options<SearchClickFeedbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, SearchClickFeedbackError, Options<SearchClickFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await searchClickFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSmartSearchLocationsQueryKey = (options?: Options<GetSmartSearchLocationsData>) => createQueryKey('getSmartSearchLocations', options);

/**
 * Get smart search opt-in status per owner for locations the user can manage.
 */
export const getSmartSearchLocationsOptions = (options?: Options<GetSmartSearchLocationsData>) => queryOptions<GetSmartSearchLocationsResponse, GetSmartSearchLocationsError, GetSmartSearchLocationsResponse, ReturnType<typeof getSmartSearchLocationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSmartSearchLocations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSmartSearchLocationsQueryKey(options)
});

/**
 * Opt in or out of smart search for one or more restaurants.
 */
export const updateSmartSearchOptInMutation = (options?: Partial<Options<UpdateSmartSearchOptInData>>): UseMutationOptions<UpdateSmartSearchOptInResponse, UpdateSmartSearchOptInError, Options<UpdateSmartSearchOptInData>> => {
    const mutationOptions: UseMutationOptions<UpdateSmartSearchOptInResponse, UpdateSmartSearchOptInError, Options<UpdateSmartSearchOptInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSmartSearchOptIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert smart search answer feedback
 *
 * Creates or updates thumb feedback (0/1) for a smart search answer trace. An optional written comment may be included with the thumb rating.
 */
export const upsertSmartSearchFeedbackMutation = (options?: Partial<Options<UpsertSmartSearchFeedbackData>>): UseMutationOptions<UpsertSmartSearchFeedbackResponse, UpsertSmartSearchFeedbackError, Options<UpsertSmartSearchFeedbackData>> => {
    const mutationOptions: UseMutationOptions<UpsertSmartSearchFeedbackResponse, UpsertSmartSearchFeedbackError, Options<UpsertSmartSearchFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertSmartSearchFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Natural Language Translations
 *
 * Facilitates translation from one natural language to another.
 */
export const getTranslationsMutation = (options?: Partial<Options<GetTranslationsData>>): UseMutationOptions<GetTranslationsResponse, GetTranslationsError, Options<GetTranslationsData>> => {
    const mutationOptions: UseMutationOptions<GetTranslationsResponse, GetTranslationsError, Options<GetTranslationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getTranslations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUsersForLocationsQueryKey = (options?: Options<GetUsersForLocationsData>) => createQueryKey('getUsersForLocations', options);

/**
 * Find users assigned to locations
 *
 * Find users assigned to locations.
 */
export const getUsersForLocationsOptions = (options?: Options<GetUsersForLocationsData>) => queryOptions<GetUsersForLocationsResponse, GetUsersForLocationsError, GetUsersForLocationsResponse, ReturnType<typeof getUsersForLocationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsersForLocations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersForLocationsQueryKey(options)
});

export const getUsersQueryKey = (options?: Options<GetUsersData>) => createQueryKey('getUsers', options);

/**
 * Get users by locations
 *
 * @deprecated
 */
export const getUsersOptions = (options?: Options<GetUsersData>) => queryOptions<GetUsersResponse, GetUsersError, GetUsersResponse, ReturnType<typeof getUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersQueryKey(options)
});

export const getOperatorsQueryKey = (options?: Options<GetOperatorsData>) => createQueryKey('getOperators', options);

/**
 * Get operators and locations
 */
export const getOperatorsOptions = (options?: Options<GetOperatorsData>) => queryOptions<GetOperatorsResponse, GetOperatorsError, GetOperatorsResponse, ReturnType<typeof getOperatorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOperators({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOperatorsQueryKey(options)
});

export const getUserPreferencesQueryKey = (options?: Options<GetUserPreferencesData>) => createQueryKey('getUserPreferences', options);

/**
 * Retrieve user preferences
 */
export const getUserPreferencesOptions = (options?: Options<GetUserPreferencesData>) => queryOptions<GetUserPreferencesResponse, GetUserPreferencesError, GetUserPreferencesResponse, ReturnType<typeof getUserPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserPreferencesQueryKey(options)
});

/**
 * Save user preferences
 */
export const saveUserPreferencesMutation = (options?: Partial<Options<SaveUserPreferencesData>>): UseMutationOptions<SaveUserPreferencesResponse, SaveUserPreferencesError, Options<SaveUserPreferencesData>> => {
    const mutationOptions: UseMutationOptions<SaveUserPreferencesResponse, SaveUserPreferencesError, Options<SaveUserPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveUserPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserPlanAssignmentSummariesQueryKey = (options: Options<GetUserPlanAssignmentSummariesData>) => createQueryKey('getUserPlanAssignmentSummaries', options);

/**
 * Get User Plan Assignment Summaries
 *
 * Returns a summary of the user's plan assignments.
 */
export const getUserPlanAssignmentSummariesOptions = (options: Options<GetUserPlanAssignmentSummariesData>) => queryOptions<GetUserPlanAssignmentSummariesResponse, GetUserPlanAssignmentSummariesError, GetUserPlanAssignmentSummariesResponse, ReturnType<typeof getUserPlanAssignmentSummariesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserPlanAssignmentSummaries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserPlanAssignmentSummariesQueryKey(options)
});

/**
 * Store quiz results for plan from Typeform
 */
export const webhookQuizMutation = (options?: Partial<Options<WebhookQuizData>>): UseMutationOptions<unknown, WebhookQuizError, Options<WebhookQuizData>> => {
    const mutationOptions: UseMutationOptions<unknown, WebhookQuizError, Options<WebhookQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await webhookQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
